module.exports = __webpack_public_path__ + "img/subAra2.a3f9654b.jpg";